export default __webpack_public_path__ + "static/media/map-placeholder.4a9f661e.png";